import { InteractionMetric, ITagGroup } from "@edgetier/watchtower-types";

/**
 * Create a minimum or maximum interaction metric field name.
 * @param interactionMetricName Name of an interaction type.
 * @param type                  Maximum or minimum.
 * @returns                     Field name.
 */
export const createInteractionMetricParameterName = (
    interactionMetricName: InteractionMetric,
    type: "maximum" | "minimum"
): any => {
    const titleCase = interactionMetricName.toString().replace(/^./, (firstLetter) => firstLetter.toUpperCase());
    return `${type}${titleCase}`;
};

/**
 * Get the initial tag groups to display. Some tag groups are marked as common and they should always be visible.
 * @param tagGroups All available tag groups.
 * @returns         Names of tag groups fields to display.
 */
export const getVisibleTagGroupFields = (tagGroups: ITagGroup[]) => {
    return tagGroups.filter(({ isCommonFilter }) => isCommonFilter).map(({ tagGroupId }) => `tagGroups.${tagGroupId}`);
};
